import { ChangeEvent } from 'react';
import { CurrencyFormatter } from '@utils/formatters/CurrencyFormatter';
import { NEXT_PUBLIC_NO_PRICE_FALLBACK } from '@config/environment';
import {
  RootDiv,
  HorizontalLineFull,
  LocalTitleText,
  SelectPayment,
  SelectPaymentOption,
  MixDiv,
  MixText,
  MixInput,
  MixAmount,
} from '../styles/LocalPaymentOptions.styles';
import { TransferDivComponent } from './TransferDiv';
import {
  useLocalPaymentOption,
  useLocalPaymentOptionsActions,
} from '../zustand/localPaymentOptionsStore';
import { LocalPaymentOptionsTypes } from '../zustand/interfaces';

interface LocalPaymentOptionsProps {
  changePaymentAmount: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function LocalPaymentOptions(props: LocalPaymentOptionsProps) {
  const { changePaymentAmount } = props;

  const { paymentOption, mixPayments } = useLocalPaymentOption();
  const { setPaymentOption } = useLocalPaymentOptionsActions();

  const handleOnChange = (item: string) => {
    setPaymentOption(item as LocalPaymentOptionsTypes);
  };
  const currFormat = new CurrencyFormatter({
    fallback: NEXT_PUBLIC_NO_PRICE_FALLBACK,
  });

  return (
    <RootDiv>
      <LocalTitleText>Métodos de pago</LocalTitleText>
      <HorizontalLineFull />
      <SelectPayment onChange={(item) => handleOnChange(item.target.value)}>
        <SelectPaymentOption value="none" selected disabled hidden>
          Seleccionar método de pago
        </SelectPaymentOption>
        <SelectPaymentOption value="CASH">Efectivo</SelectPaymentOption>
        <SelectPaymentOption value="CARD">Tarjeta</SelectPaymentOption>
        <SelectPaymentOption value="TRANSFER">
          Transferencia
        </SelectPaymentOption>
        <SelectPaymentOption value="CARD_CASH">
          Efectivo + Tarjeta
        </SelectPaymentOption>
      </SelectPayment>
      {paymentOption === 'TRANSFER' && <TransferDivComponent />}
      {paymentOption === 'CARD_CASH' && (
        <>
          <MixDiv>
            <MixText>Efectivo</MixText>
            <MixInput
              value={mixPayments.CASH}
              onChange={(event) => changePaymentAmount(event)}
            />
          </MixDiv>
          <MixDiv>
            <MixText>Tarjeta</MixText>
            <MixAmount>{currFormat.format(mixPayments.CARD)}</MixAmount>
          </MixDiv>
        </>
      )}
    </RootDiv>
  );
}
